import { shallow } from 'zustand/shallow'
import { createWithEqualityFn } from 'zustand/traditional'

import { API, isAxiosError } from '../../lib/api'
import { useUserStore } from '../user'
import { AppState } from './types'

export const useAppStore = createWithEqualityFn<AppState>(
  (set, get) => ({
    releaseInfo: [],
    getReleaseInfo: async () => {
      const { locale } = useUserStore.getState()
      const releaseInfo = (await API.getReleaseInfo(locale)) ?? []
      if (isAxiosError(releaseInfo)) return []
      set({ releaseInfo })
      return releaseInfo
    },
    markReleaseInfoAsRead: (id: string) => {
      const updatedReleaseInfo = get().releaseInfo.map((release) =>
        release.id === id ? { ...release, isRead: true } : release,
      )
      set({ releaseInfo: updatedReleaseInfo })
      API.markReleaseInfoAsRead(id)
    },
    resetReleaseInfo: () => {
      set({ releaseInfo: [] })
    },
  }),
  shallow,
)
